import { BaseWebComponent } from "./webcomponent-base";

export class SidebarHeaderWebComponent extends BaseWebComponent {
    static webComponentName = "wc-sidebar-header";
    static observedAttributes = [];

    get href(): string {
        return this.getAttribute('href') || "#";
    }
    get logo(): string {
        return this.getAttribute('logo') || "";
    }
    get title(): string {
        return this.getAttribute('title') || "";
    }
    get subtitle(): string {
        return this.getAttribute('subtitle') || "";
    }
    get toggler(): boolean {
        const attr = this.getAttribute('toggler');
        return !attr || attr !== 'false';
    }
    constructor() {
        super();
        this.classList.add('sidebar-header');
    }


    protected onConnected(): void {
        this.render();
    }

    render(): void {
        const lines = [];
        lines.push(`<a href="${this.href}" class="sidebar-brand">`);
        if (this.logo) {
            lines.push(`<img src="${this.logo}" alt="${this.title}" class="sidebar-logo">`);
        }
        lines.push(`<span class="sidebar-brand-text">`);
        lines.push(`<span class="sidebar-brand-text-title">${this.title}</span>`);
        if (this.subtitle) {
            lines.push(`<span class="sidebar-brand-text-subtitle">${this.subtitle}</span>`);
        }
        lines.push(`</span>`);
        lines.push(`</a>`);
        if (this.toggler) {
            lines.push(`<wc-sidebar-toggle></wc-sidebar-toggle>`);
        }
        this.innerHTML = lines.join('\n');
    }
}

